import PropTypes from 'prop-types';
import React from 'react';
import ButtonSubmitDeprecated from 'core/gd-form/common/btn-submit/btn-submit.tsx';
import Button from 'gd-comp-button';

import Classes from 'classnames';

// Deprecated

class GDFormModal extends React.Component {
    static propTypes = {
        submitLabel: PropTypes.string,
        form: PropTypes.object.isRequired,

        submitButton: PropTypes.bool,
        cancelButton: PropTypes.bool,
        onCancelClick: PropTypes.func
    };

    static defaultProps = {
        submitLabel: 'Submit',
        submitButton: true,
        cancelButton: false
    };

    render() {
        let buttonCancel;

        if (this.props.cancelButton===true) {
            buttonCancel = <Button type="normal" label="Cancel" onClick={this.props.onCancelClick} className="btn-cancel" />
        }

        return (
            <div className={Classes("gd-form-modal", this.props.className)} style={this.props.style}>

                {this.props.children}

                {(this.props.submitButton || this.props.cancelButton) &&
                <div className="actions">
                    <ButtonSubmitDeprecated form={this.props.form} label={this.props.submitLabel} className="submit" /> {buttonCancel}
                </div>}

            </div>
        );
    }
}

module.exports = GDFormModal;